import {
  deleteAdminV1StoresStoreIdQcTemplatesId,
  deleteAdminV1StoresStoreIdWorkflowTemplatesId,
  getAdminV1StoresStoreIdQcTemplates,
  getAdminV1StoresStoreIdQcTemplatesId,
  getAdminV1StoresStoreIdWorkflowTemplates,
  getAdminV1StoresStoreIdWorkflowTemplatesId,
  patchAdminV1StoresStoreIdQcTemplatesId,
  patchAdminV1StoresStoreIdWorkflowTemplatesId,
  postAdminV1StoresStoreIdQcTemplates,
  postAdminV1StoresStoreIdWorkflowTemplates,
  postAdminV1StoresStoreIdWorkflowTemplatesIdDuplicate,
  postAdminV1StoresStoreIdWorkflowTemplatesIdMakeDefault,
  type PatchAdminV1StoresStoreIdQcTemplatesIdBody,
  type PatchAdminV1StoresStoreIdWorkflowTemplatesIdBody,
  type PostAdminV1StoresStoreIdQcTemplatesBody,
  type PostAdminV1StoresStoreIdWorkflowTemplatesBody,
  type PostAdminV1StoresStoreIdWorkflowTemplatesIdDuplicateBody,
  type QcTemplate,
  type WorkflowTemplate,
  type WorkflowTemplateSummary,
} from '@nucleus-commerce/api-client/admin';

/** Workflow templates of one store: bounded (20), so the list comes back whole. */
export const workflowTemplatesApi = {
  list: (storeId: string): Promise<WorkflowTemplate[]> =>
    getAdminV1StoresStoreIdWorkflowTemplates({ storeId }).then((r) =>
      r.items.filter((t): t is WorkflowTemplate => 'stages' in t),
    ),
  /** Names only, readable with `orders.write`; what the order's switch dialog lists. */
  summaries: (storeId: string): Promise<WorkflowTemplateSummary[]> =>
    getAdminV1StoresStoreIdWorkflowTemplates({ storeId }, { summary: 'true' }).then((r) =>
      r.items.map(({ id, name, isDefault }) => ({ id, name, isDefault })),
    ),
  get: (storeId: string, id: string): Promise<WorkflowTemplate> =>
    getAdminV1StoresStoreIdWorkflowTemplatesId({ storeId, id }),
  create: (
    storeId: string,
    body: PostAdminV1StoresStoreIdWorkflowTemplatesBody,
  ): Promise<WorkflowTemplate> => postAdminV1StoresStoreIdWorkflowTemplates({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdWorkflowTemplatesIdBody,
  ): Promise<WorkflowTemplate> =>
    patchAdminV1StoresStoreIdWorkflowTemplatesId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdWorkflowTemplatesId({ storeId, id }),
  makeDefault: (storeId: string, id: string): Promise<WorkflowTemplate> =>
    postAdminV1StoresStoreIdWorkflowTemplatesIdMakeDefault({ storeId, id }),
  duplicate: (
    storeId: string,
    id: string,
    body: PostAdminV1StoresStoreIdWorkflowTemplatesIdDuplicateBody,
  ): Promise<WorkflowTemplate> =>
    postAdminV1StoresStoreIdWorkflowTemplatesIdDuplicate({ storeId, id }, body),
};

/** QC checklists of one store: bounded (20), returned whole. */
export const qcTemplatesApi = {
  list: (storeId: string): Promise<QcTemplate[]> =>
    getAdminV1StoresStoreIdQcTemplates({ storeId }).then((r) => r.items),
  get: (storeId: string, id: string): Promise<QcTemplate> =>
    getAdminV1StoresStoreIdQcTemplatesId({ storeId, id }),
  create: (storeId: string, body: PostAdminV1StoresStoreIdQcTemplatesBody): Promise<QcTemplate> =>
    postAdminV1StoresStoreIdQcTemplates({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdQcTemplatesIdBody,
  ): Promise<QcTemplate> => patchAdminV1StoresStoreIdQcTemplatesId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdQcTemplatesId({ storeId, id }),
};
